import { Injectable } from '@angular/core';

declare var google: any;
/**
 * this will be the resuable component services
 * load the library and manage the callback
 */
@Injectable()
export class GoogleChartsService {
  constructor() {
    google.charts.load('current', { packages: ['corechart'] });
  }

  protected buildChart(data: any[], chartFunc: any, options: any): void {
    const func = (chartFunction, configOptions) => {
      const datatable = google.visualization.arrayToDataTable(data);
      chartFunc().draw(datatable, options);
    };
    const callback = () => func(chartFunc, options);
    google.charts.setOnLoadCallback(callback);
  }
}
